package de.xtl.retroguide.question

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import de.xtl.retroguide.protocol.ActionItem
import de.xtl.retroguide.protocol.MAX_ACTION_DUE_LENGTH
import de.xtl.retroguide.protocol.MAX_ACTION_WHAT_LENGTH
import de.xtl.retroguide.protocol.MAX_ACTION_WHO_LENGTH
import de.xtl.retroguide.protocol.toActionItem
import org.jetbrains.compose.resources.stringResource
import retroguide.app.shared.generated.resources.Res
import retroguide.app.shared.generated.resources.action_item_due
import retroguide.app.shared.generated.resources.action_item_what
import retroguide.app.shared.generated.resources.action_item_who

@Composable
internal fun ActionItemInput(
    value: String,
    enabled: Boolean,
    onValueChange: (String) -> Unit,
) {
    val draft = value.toActionItem() ?: ActionItem("")
    OutlinedTextField(
        value = draft.what,
        onValueChange = { onValueChange(draft.copy(what = it.take(MAX_ACTION_WHAT_LENGTH)).encode()) },
        label = { Text(stringResource(Res.string.action_item_what)) },
        enabled = enabled,
        minLines = 2,
        modifier = Modifier.fillMaxWidth(),
    )
    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        OutlinedTextField(
            value = draft.who,
            onValueChange = { onValueChange(draft.copy(who = it.take(MAX_ACTION_WHO_LENGTH)).encode()) },
            label = { Text(stringResource(Res.string.action_item_who)) },
            enabled = enabled,
            singleLine = true,
            modifier = Modifier.weight(1f),
        )
        OutlinedTextField(
            value = draft.due,
            onValueChange = { onValueChange(draft.copy(due = it.take(MAX_ACTION_DUE_LENGTH)).encode()) },
            label = { Text(stringResource(Res.string.action_item_due)) },
            enabled = enabled,
            singleLine = true,
            modifier = Modifier.weight(1f),
        )
    }
}

@Composable
internal fun ActionItemContent(item: ActionItem) {
    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(item.what, style = MaterialTheme.typography.titleLarge)
        val chips = listOfNotNull(
            item.who.takeIf { it.isNotBlank() }?.let { "👤 $it" },
            item.due.takeIf { it.isNotBlank() }?.let { "📅 $it" },
        )
        if (chips.isNotEmpty()) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                chips.forEach { chip ->
                    Surface(shape = RoundedCornerShape(50), color = MaterialTheme.colorScheme.tertiaryContainer) {
                        Text(
                            chip,
                            modifier = Modifier.padding(horizontal = 10.dp, vertical = 4.dp),
                            style = MaterialTheme.typography.labelLarge,
                        )
                    }
                }
            }
        }
    }
}
